import { L10nConfig } from 'angular-l10n';
export const l10nVersion = '1.0.0';
export const l10nConfig: L10nConfig = {
  format: 'language-region',
  providers: [
    {
      name: 'app',
      asset: './assets/i18n/locale',
      options: { version: l10nVersion },
    },
    {
      name: 'bi',
      asset: './assets/i18n/bi/locale',
      options: { version: l10nVersion },
    },
    {
      // Texts of the feature-flags admin panel, from the core's submodule (WB-193).
      name: 'ff',
      asset: './assets/i18n/ff/locale',
      options: { version: l10nVersion },
    },
  ],
  cache: true,
  keySeparator: '.',
  defaultLocale: { language: 'es-ES', currency: 'USD' },
  schema: [
    {
      locale: { language: 'es-ES', currency: 'EUR' },
      dir: 'ltr',
      text: 'Español',
    },
  ],
};
